<script lang="ts">
import Button from './Button.vue';
import CardBodyLine from './CardBodyLine.vue';
import CardTitle from './CardTitle.vue';
import { useIsMobileMixin } from '../lib/use-is-mobile-mixin';

export default {
  name: 'CardLayout',
  components: {
    Button,
    CardBodyLine,
    CardTitle
  },
  props: {
    title: {
      type: String,
      required: true
    },
    body: {
      type: Object,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    buttonHref: {
      type: String,
      required: true
    },
    buttonDataLayerEvent: {
      type: Object,
      default: null
    },
    buttonDisabled: {
      type: Boolean,
      default: false
    }
  },
  mixins: [useIsMobileMixin],
  methods: {
    handleButtonClick() {
      // Push the provided data layer event directly
      if (this.buttonDataLayerEvent && typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push(this.buttonDataLayerEvent);
      }
    }
  }
};
</script>
<template>
  <div class="root" :class="{ 'is-mobile': isMobile, 'is-desktop': !isMobile }">
    <slot name="art" />
    <slot name="title">
      <CardTitle :title="title" />
    </slot>
    <slot name="body">
      <div v-for="block in body.blocks" :key="block.lines.join('')">
        <CardBodyLine v-for="line in block.lines" :key="line" :body="line" />
      </div>
    </slot>
    <slot name="button">
      <Button
        :label="buttonText"
        color="maroon"
        :href="buttonHref"
        :disabled="buttonDisabled"
        @click="handleButtonClick"
      />
    </slot>
  </div>
</template>

<style scoped>
.root {
  background-color: #fafafa;
  border: 1px solid #bfbfbf;
  border-radius: 16px;
  width: 100%;
  max-width: 790px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
}
.is-mobile {
  padding: 24px;
}
.is-desktop {
  padding: 64px;
}
</style>
